import { createFileRoute, useRouter } from '@tanstack/react-router'

import styles from './styles.module.scss'
import { HeaderMobile } from '@/components/mobile/header'
import { CardWinner } from '@/components/ui/card-winner'
import { cardsServiceInstance } from '@/services/cards.service'
import { useCallback } from 'react'
import Marquee from "react-easy-marquee";

export const Route = createFileRoute('/mobile/home/')({
  component: RouteComponent,
  loader: async () => {
    const [winners, mePendingCards] = await Promise.all([
      cardsServiceInstance.winners(),
      cardsServiceInstance.mePending(),
    ])
    return {
      winners,
      mePendingCards
    }
  },
  shouldReload: true,
})

function RouteComponent() {
  const { winners, mePendingCards } = Route.useLoaderData()
  const router = useRouter()

  const navigate = useCallback(() => {
    if (mePendingCards > 0) {
      router.navigate({
        to: '/mobile/game'
      })
      return
    }

    router.navigate({
      to: "/mobile/buy-cards"
    })
  }, [mePendingCards])


  return (
    <div className={styles.container}>
      <HeaderMobile quantityCards={mePendingCards} />
      <div className={styles.container_cards_image}>
        <img
          src="/assets/home_cards.png"
        />

        <button
          onClick={navigate}
        >
          <img src="/assets/btn_vermelho.png" />
        </button>
      </div>
      <div className={styles.container_winners}>
        <img
          src="/assets/winners.png"
        />
        <Marquee reverse duration={50000} width='100dvw' height="120px">
          {
            winners.map((w) => (
              <CardWinner
                phoneNumber={w.phoneNumber}
                username={w.username}
                value={w.value}
              />
            ))
          }
        </Marquee>

      </div>

    </div>
  )
}
